export const delay = async (until = 0) => {
  return new Promise<void>((resolve) => {
    setTimeout(resolve, until);
  });
};
